import React from "react";
import axios from "axios";
import { Field, FieldArray, Form, Formik } from "formik";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as Yup from "yup";

import { FieldGroup } from "../../../components";

const validationSchema = Yup.object({
  events: Yup.array().of(
    Yup.object({
      event_id: Yup.string().required("Event name is required"),
      date: Yup.date().required("Event date is required"),
      status: Yup.string().required("Status is required"),
    })
  ),
});

const UserEventList = ({
  user,
  eventList,
  userEventList,
  onCreateNewEvent,
}) => {
  const statusOptions = [
    { id: "invited", name: "Invited" },
    { id: "registered", name: "Registered" },
    { id: "waitlist", name: "Waitlist" },
    { id: "declined", name: "Declined" },
    { id: "email_opened", name: "Email opened" },
    { id: "called_by_karen", name: "Called by Karen" },
    { id: "called_by_liam", name: "Called by Liam" },
    { id: "called_by_team", name: "Called by Team" },
    { id: "call_unsuccessful_by_ai", name: "Call unsuccessful by AI" },
    { id: "call_unsuccessful_by_team", name: "Call unsuccessful by Team" },
  ];

  const initialValues = {
    events:
      userEventList?.length > 0
        ? userEventList.map((event) => ({
            event_id: event.event_id,
            date: new Date(event.date),
            status: event.status,
          }))
        : [
            {
              event_id: "",
              date: null,
              status: "",
            },
          ],
  };

  const handleAddRow = (push) => {
    push({
      event_id: "",
      date: null,
      status: "",
    });
  };

  const handleRemoveRow = (index, remove) => {
    remove(index);
  };

  const onSubmit = async (values) => {
    await axios.post("/api/user-events", {
      user_id: user.id,
      events: values.events,
    });
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ values, setFieldValue }) => (
        <Form className="user-events">
          <FieldArray name="events">
            {({ push, remove }) => (
              <div className="user-events__list">
                {values.events.map((event, index) => (
                  <div key={index} className="user-events__row">
                    <div className="user-events__field">
                      <FieldGroup
                        name={`events[${index}].event_id`}
                        type="select"
                        options={eventList}
                        placeholder="Event"
                      />
                    </div>

                    <div className="user-events__field user-events__field--date">
                      <Field name={`events[${index}].date`}>
                        {({ field }) => (
                          <DatePicker
                            {...field}
                            selected={field.value}
                            onChange={(date) =>
                              setFieldValue(`events[${index}].date`, date)
                            }
                            dateFormat="yyyy-MM-dd"
                            placeholderText="Select Date"
                            className="user-events__datepicker"
                          />
                        )}
                      </Field>
                    </div>

                    <div className="user-events__field">
                      <FieldGroup
                        name={`events[${index}].status`}
                        type="select"
                        options={statusOptions}
                        placeholder="Status"
                      />
                    </div>

                    <div className="user-events__action">
                      {index === values.events.length - 1 ? (
                        <button
                          type="button"
                          className="user-events__icon-btn user-events__icon-btn--add"
                          onClick={() => handleAddRow(push)}
                          aria-label="Add event row"
                        >
                          +
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="user-events__icon-btn user-events__icon-btn--remove"
                          onClick={() => handleRemoveRow(index, remove)}
                          aria-label="Remove event row"
                        >
                          −
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </FieldArray>

          <div className="user-events__footer">
            <button
              type="button"
              className="user-events__btn user-events__btn--secondary"
              onClick={() => onCreateNewEvent()}
            >
              Create New Event
            </button>
            <button
              type="submit"
              className="user-events__btn user-events__btn--primary"
            >
              Save
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default UserEventList;
